import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/whale.png'


const _withScopeId = n => (_pushScopeId("data-v-bd9b1cb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center-container" }
const _hoisted_2 = { class: "wrap_signin" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_next" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "signin_image"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin_title" }, " 커스텀보이스 채팅 BETA ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin_subtitle" }, " 계정과 비밀번호를 입력해주세요. ", -1))
const _hoisted_6 = { class: "wrap_signin_input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_string" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"85%","border":"1px #EAEAEA solid"} })
], -1))
const _hoisted_8 = { class: "wrap_next" }

import { useRoute } from 'vue-router';
import {
  ref,
  watch,
} from 'vue';
import { notification as AntNotification } from 'ant-design-vue/lib/components';
import { Modal } from 'ant-design-vue';
import { useWebSocketStore } from '../stores/storeWebSocket';
import { userStore } from '../stores/storeAuth';
import {
  setLocalStorage,
  setStorage,
  getStorage,
} from '@utils/storageUtils';
import { pushPage } from '@utils/route.helper';
import router from '@router';
import { errorType } from '@interface/error';
import {
  postLogin,
  getSignedUserInfo,
} from '@apis/voicechat';
import axiosInstance from '@apis/axiosInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const userData = userStore();
const userId = ref('');
const userPwd = ref('');
const isLoggingIn = ref(false);
const keeplogin = ref(false);
const route = useRoute();

// 로그인
const postSignIn = async () => {
  if (isLoggingIn.value) {
    return; // 이미 요청 중이면 중복 요청 방지
  }
  if (!userId.value) {
    alert('이메일을 입력해주세요');
    return;
  }
  if (!userPwd.value) {
    alert('비밀번호를 입력해주세요');
    return;
  }

  const params = {
    user_id: userId.value,
    pwd: userPwd.value,
  };

  console.log('nextStep', userId.value);

  try {
    isLoggingIn.value = true;
    const result = await postLogin(params);
    userData.$reset();
    localStorage.clear();
    sessionStorage.clear();
    const accessTokenValue = result.data.access_token;

    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessTokenValue}`;
    if (keeplogin.value) {
      setLocalStorage('accessToken', accessTokenValue);
      setLocalStorage('userId', userId.value);
      userData.userId = userId.value;
    } else {
      setStorage('accessToken', accessTokenValue);
      setStorage('userId', userId.value);
      userData.userId = userId.value;
    }
    router.push({ name: 'chatUser' });
  } catch (e) {
    console.log('error', e);
    AntNotification.error({ message: '비밀번호가 일치하지 않습니다. 입력한 내용을 다시 확인해 주세요.' });
  } finally {
    isLoggingIn.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userId).value = $event)),
          type: "email",
          placeholder: "아이디",
          class: "signin_input"
        }, null, 512), [
          [_vModelText, userId.value]
        ]),
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userPwd).value = $event)),
          type: "password",
          placeholder: "비밀번호",
          class: "signin_input"
        }, null, 512), [
          [_vModelText, userPwd.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "next",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (postSignIn()))
        }, " NEXT ")
      ]),
      _createElementVNode("div", {
        class: "sign_up",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(pushPage)('signUp')))
      }, " 계정이 없으신가요? ")
    ])
  ]))
}
}

})